// myRoutes.ts
import React from "react";
import { Link } from "react-router-dom";
import { myRoutes, Route } from "../../utils/routes";

const renderLinks = (routes: Route[], basePath = "") => {
  return routes.map((route) => (
    <div key={route.path} className="flex flex-col ml-4">
      <Link to={basePath + route.path}>{route.label}</Link>
      {route.children && renderLinks(route.children, basePath)}
    </div>
  ));
};

const Navigation = () => {
  return (
    <div className="flex gap-4 flex-col my-5 mx-4">{renderLinks(myRoutes)}</div>
  );
};

export default Navigation;
